import { createUseStyles } from "react-jss";
import breakpoints from "assets/breakpoints";
export const useStyles = createUseStyles({
  landing__page: {
    backgroundSize: "cover",
    backgroundPosition: "center",
    minHeight: "100vh",
    "&:before, &:after": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      zIndex: 0,
    },
    "&:before": {
      // background:"linear-gradient(rgb(var(--black)), rgb(var(--black) / 0.20), rgb(var(--black)))",
      background:
        "linear-gradient(180deg, rgb(var(--black) / 0.80), rgb(var(--black) / 0.0))",
      opacity: 0.5,
    },
    "&:after": {
      background: "rgb(var(--black) / 0.80)",
    },
    "& .headerCommon": {
      "& .btn-link": {
        color: "rgb(var(--white)) !important",
        "&:hover": {
          textDecoration: "none",
        },
      },
    },
    // lanp__search
    "& .lanp__search": {
      backgroundColor: "rgb(var(--white))",
      padding: "16px 16px 16px 30px",
      "& .container-xxl": {
        maxWidth: "100%",
        padding: "0",
      },
      "& .form__row": {
        // gap: "30px",
        "& .fr__items": {
          borderRadius: "50rem",
          "&.fr__pathway, &.fr__spathway, &.fr__keyword, &.fr__county": {
            maxWidth: "200px",
            paddingRight: '22px',
            [breakpoints.SCREEN_XL_MIN]: {
              maxWidth: "230px",
              paddingRight: '30px',
            },
            "&:after": {
              content: "''",
              width: "1px",
              height: "30px",
              backgroundColor: "rgb(var(--dark) / 0.10) !important",
              position: "absolute",
              top: "50%",
              right: "15px",
              transform: 'translateY(-50%)',
            },
          },
          "&.fr__orgname": {
            minWidth: "130px",
            paddingRight: '11px',
            [breakpoints.SCREEN_XL_MIN]: {
              minWidth: "160px",
              paddingRight: '14px',
            },
          },
          "&.fr__action": {
            "& .fr__ibox": {
              "& > button": {
                minHeight: "46px",
                "&:hover": {
                  "& > svg": {
                    animation: "org__pop 0.4s linear infinite",
                  },
                },
              },
            },
          },
        },
      },
    },
    "& .lp__body": {
      minHeight: "calc(100vh - 136px)",
      [breakpoints.SCREEN_LG_MIN]: {
        top: "-60px",
      },
      "& .lp__title": {
        maxWidth: "1100px",
        "& > h2": {
          lineHeight: "1.4",
          [breakpoints.SCREEN_MDS_MAX]: {
            fontSize: "28px",
          },
        },
        "& > p": {
          fontWeight: "var(--fw-300)",
          fontSize: "18px",
          [breakpoints.SCREEN_MD_MAX]: {
            fontSize: "15px",
          },
        },
      },
      "& .mobile__hsearch": {
        "& .mobile__form": {
          backgroundColor: "rgb(var(--white))",
          margin: "0 auto",
          borderRadius: "50rem",
          padding: "12px 34px",
          height: "78px",
          "& .mobile__forml": {
            "& > h4": {
              fontSize: "16px",
            },
            "& > span": {
              fontSize: "13px",
              marginTop: "2px",
            },
          },
          "& .mobile__formr": {
            "& > svg": {
              fontSize: "20px",
            },
          },
        },
        "& .offcanvas": {
          "&.offcanvas-bottom": {},
        },
      },
    },
    "& .footerCommon": {
      "& svg": {
        "& > path": {
          fill: "rgb(var(--white))",
        },
      },
      "& span": {
        color: "rgb(var(--white))",
      },
    },
  },
});
